import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-iaa-osaka-auction',
  templateUrl: './iaa-osaka-auction.component.html',
  styleUrls: ['./iaa-osaka-auction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IaaOsakaAuctionComponent {
  @Input() lang = 'ru';
}
